import App from '@/page/baseInfo/App'


import Detail from '@/components/template/detail.vue'

export const baseInfo = [{
    path: 'baseInfo/node/app',
    name: 'app',
    component: App,
    meta: {
        requireAuth: true,
        title: '节点应用系统'
    }
}];


// WEBPACK FOOTER //
// ./src/router/baseInfo.route.js